import {NativeUserTrackingService} from './../core/user/infrastructure/native-user-tracking.service';
import {UserTrackingService} from './../core/user/domain/user-tacking.service';
import {LargeStorageLocal} from '@app/core/shared/domain/storage/large-storage.local';
import {Capacitor} from '@capacitor/core';
import {StorageCookiesLocalStorage} from '@app/core/shared/infrastructure/storage/storage-cookies.local-storage';
import {BannerRemote} from "@app/core/banner/domain/banner.remote";
import {BannerWebService} from "@app/core/banner/infrastructure/banner.web-service";
import {CartRemote} from "@app/core/cart/domain/cart.remote";
import {CartWebService} from "@app/core/cart/infrastructure/cart.web-service";
import {CategoryRemote} from "@app/core/category/domain/category.remote";
import {CategoryWebService} from "@app/core/category/infrastructure/category.web-service";
import {ContactRemote} from "@app/core/contact/domain/contact.remote";
import {ContactWebService} from "@app/core/contact/infrastructure/contact.web-service";
import {CouponRemote} from "@app/core/coupon/domain/coupon.remote";
import {CouponWebService} from "@app/core/coupon/infrastructure/coupon.web-service";
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";
import {CredentialsLocalStorage} from "@app/core/credentials/infrastructure/credentials.local-storage";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {DeliveryPointRemote} from "@app/core/delivery-point/domain/delivery-point.remote";
import {GeolocationService} from "@app/core/delivery-point/domain/geolocation.service";
import {CapacitorGeolocationService} from "@app/core/delivery-point/infrastructure/capacitor-geolocation.service";
import {DeliveryPointLocalStorage} from "@app/core/delivery-point/infrastructure/delivery-point.local-storage";
import {DeliveryPointWebService} from "@app/core/delivery-point/infrastructure/delivery-point.web-service";
import {ListRemote} from "@app/core/lists/domain/list.remote";
import {ListWebService} from "@app/core/lists/infrastructure/list.web-service";
import {OrderRemote} from "@app/core/my-order/domain/repository/order.remote";
import {OrderWebService} from "@app/core/my-order/infrastructure/order.web-service";
import {ProductComparisonLocal} from "@app/core/product/domain/repositories/product-comparison.local";
import {ProductSearchLocal} from "@app/core/product/domain/repositories/product-search.local";
import {ProductRemote} from "@app/core/product/domain/repositories/product.remote";
import {ProductComparisonLocalStorage} from "@app/core/product/infrastructure/product-comparison.local-storage";
import {ProductSearchLocalStorage} from "@app/core/product/infrastructure/product-search.local-storage";
import {ProductWebService} from "@app/core/product/infrastructure/product.web-service";
import {PromotionRemote} from "@app/core/promotion/domain/repository/promotion.remote";
import {PromotionWebService} from "@app/core/promotion/infrastructure/promotion.web-service";
import {AppVersionNative} from "@app/core/shared/domain/app-version.native";
import {PlatformUtils} from "@app/core/shared/domain/platform.utils";
import {StorageLocal} from "@app/core/shared/domain/storage/storage.local";
import {WindowService} from "@app/core/shared/domain/window.service";
import {AppVersionCordova} from "@app/core/shared/infrastructure/app-version.cordova";
import {PlatformCdk} from "@app/core/shared/infrastructure/platform.cdk";
import {StorageLocalStorage} from "@app/core/shared/infrastructure/storage/storage.local-storage";
import {WindowClientService} from "@app/core/shared/infrastructure/window.client-service";
import {UserLocal} from "@app/core/user/domain/user.local";
import {UserRemote} from "@app/core/user/domain/user.remote";
import {UserLocalStorage} from "@app/core/user/infrastructure/user.local-storage";
import {UserWebService} from "@app/core/user/infrastructure/user.web-service";
import {CheckStockRemote} from "@app/core/stock/domain/repositories/check-stock.remote";
import {CheckStockWebService} from "@app/core/stock/infrastructure/check-stock.web-service";
import {MasterDataRemote} from "@app/core/master-data/domain/repositories/master-data.remote";
import {MasterDataWebService} from "@app/core/master-data/infrastructure/master-data.web-service";
import {DeepLinkRemote} from "@app/core/shared/domain/deep-link.remote";
import {DeepLinkWebService} from "@app/core/shared/infrastructure/deep-link.web-service";
import {OrderLocal} from "@app/core/my-order/domain/repository/order.local";
import {OrderLocalStorage} from "@app/core/my-order/infrastructure/order.local-storage";
import {LargeStorageLocalStorage} from '@app/core/shared/infrastructure/storage/large-storage.local-storage';
import {DummyUserTrackingService} from '@app/core/user/DummyUserTracking.service';
import {PushNotificationsService} from "@app/core/notifications/infrastructure/interfaces/push-notifications.service";
import {NativePushNotificationsService} from "@app/core/notifications/infrastructure/native-push-notifications.service";
import {TrackingService} from "@app/core/tracking/domain/repositories/tracking.service";
import {GTMTrackingService} from "@app/core/tracking/infrastructure/repositories/gtm-tracking.service";
import {DeepLinkService} from "@app/core/shared/infrastructure/interfaces/deep-link.service";
import {NativeDeepLinkService} from "@app/core/shared/infrastructure/native-deep-link.service";
import {UrlDeepLinkService} from "@app/core/shared/infrastructure/url-deep-link.service";
import {
  DatadogRealUserMonitoringService,
  RealUserMonitoringService
} from '@app/presentation/services/real-user-monitoring.service';
import {PdfCatalogRepo} from "@app/core/pdf-catalog/domain/repositories/pdf-catalog.repo";
import {PdfCatalogDataRepo} from "@app/core/pdf-catalog/infrastructure/pdf-catalog.data-repo";
import {
  AppTrackingTransparencyService,
  CapacitorAppTrackingTransparencyService
} from "@app/presentation/services/app-tracking-transparency.service";
import {CookieBannerService, CookiebotCookieBannerService} from "@app/presentation/services/cookie-banner.service";
import {PromoterRepo} from '@app/core/promoter/domain/promoter-repo';
import {PromoterDataRepo} from '@app/core/promoter/infrastructure/promoter.data-repo';
import {SecureStorageLocal} from '@app/core/shared/domain/storage/secure-storage.local';
import {CapacitorSecureLocalStorage} from '@app/core/shared/infrastructure/storage/capacitor.secure-local-storage';
import {CookiesSecureLocalStorage} from '@app/core/shared/infrastructure/storage/cookies.secure-local-storage';
import {CreateShareProductsLinkService} from "@app/core/product/domain/services/create-share-products-link.service";
import {
  CreateShareProductsLinkDataService
} from "@app/core/product/infrastructure/services/create-share-products-link.data-service";
import {EventService} from "@app/core/tracking/application/event-service";
import {EventDataService} from "@app/core/tracking/infrastructure/services/event-data-service";
import {AdobeExperiencePlatformService} from "@app/core/tracking/infrastructure/adobe-experience-platform-service";
import {
  NativeAdobeExperiencePlatformService
} from "@app/core/tracking/infrastructure/native-adobe-experience-platform-service";
import {
  DummyAdobeExperiencePlatformService
} from "@app/core/tracking/infrastructure/dummy-adobe-experience-platform-service";
import {MessageDisplayStrategy} from "@app/core/user-marketing-rules/application/message-display-strategy";
import {Provider} from "@angular/core";
import {AppMessageDisplayStrategy} from "@app/core/user-marketing-rules/infrastructure/app-message-display-strategy";
import {BrowserMessageDisplayStrategy} from "@app/core/user-marketing-rules/infrastructure/browser-message-display-strategy";
import {UserMarketingRulesRepository} from "@app/core/user-marketing-rules/domain/user-marketing-rules-repository";
import {
  UserMarketingRulesDataRepository
} from "@app/core/user-marketing-rules/infrastructure/user-marketing-rules-data-repository";
import {SystemClock} from "@app/core/shared/infrastructure/system-clock";
import {Clock} from "@app/core/shared/domain/clock";
import {StoredPaymentMethodRepository} from "@app/core/stored-payment-method/domain/stored-payment-method-repository";
import {
  StoredPaymentMethodDataRepository
} from "@app/core/stored-payment-method/infrastructure/stored-payment-method-data-repository";
import {PaymentMethodsDTOFinder} from "@app/core/payment-method/application/payment-methods-dto-finder";
import {PaymentMethodsDTODataFinder} from "@app/core/payment-method/infrastructure/payment-methods-data-finder";


export const repositoryProviders: Provider[] = [
  // Contact
  { provide: ContactRemote, useClass: ContactWebService },

  // Product
  { provide: ProductRemote, useClass: ProductWebService },
  { provide: ProductComparisonLocal, useClass: ProductComparisonLocalStorage },
  { provide: ProductSearchLocal, useClass: ProductSearchLocalStorage },
  { provide: CreateShareProductsLinkService, useClass: CreateShareProductsLinkDataService },

  // Credentials
  { provide: CredentialsStorage, useClass: CredentialsLocalStorage },

  // Promoter
  { provide: PromoterRepo, useClass: PromoterDataRepo },

  // User
  { provide: UserLocal, useClass: UserLocalStorage },
  { provide: UserRemote, useClass: UserWebService },
  { provide: UserTrackingService, useClass: Capacitor.isNativePlatform() ? NativeUserTrackingService : DummyUserTrackingService },
  { provide: RealUserMonitoringService, useClass: DatadogRealUserMonitoringService},

  // Delivery point
  { provide: DeliveryPointLocal, useClass: DeliveryPointLocalStorage },
  { provide: DeliveryPointRemote, useClass: DeliveryPointWebService },
  { provide: GeolocationService, useClass: CapacitorGeolocationService },

  // Cart
  { provide: CartRemote, useClass: CartWebService },

  // Shared
  { provide: PlatformUtils, useClass: PlatformCdk },
  { provide: AppVersionNative, useClass: AppVersionCordova },
  { provide: WindowService, useClass: WindowClientService },
  { provide: StorageLocal, useClass: Capacitor.isNativePlatform() ? StorageLocalStorage : StorageCookiesLocalStorage },
  { provide: LargeStorageLocal, useClass: LargeStorageLocalStorage},
  { provide: SecureStorageLocal, useClass: Capacitor.isNativePlatform() ? CapacitorSecureLocalStorage : CookiesSecureLocalStorage },
  { provide: DeepLinkRemote, useClass: DeepLinkWebService },
  { provide: DeepLinkService,  useClass: NativeDeepLinkService },
  { provide: UrlDeepLinkService, useClass: UrlDeepLinkService },
  { provide: Clock, useClass: SystemClock },

  // Category
  { provide: CategoryRemote, useClass: CategoryWebService },

  // List
  { provide: ListRemote, useClass: ListWebService },

  // Order
  { provide: OrderRemote, useClass: OrderWebService },
  { provide: OrderLocal, useClass: OrderLocalStorage },

  // Promotion
  { provide: PromotionRemote, useClass: PromotionWebService },

  // Coupon
  { provide: CouponRemote, useClass: CouponWebService },

  // Banner
  { provide: BannerRemote, useClass: BannerWebService },

  // Stock
  { provide: CheckStockRemote, useClass: CheckStockWebService },

  // Master data
  { provide: MasterDataRemote, useClass: MasterDataWebService },

  //Notification
  { provide: PushNotificationsService, useClass: NativePushNotificationsService },

  //Tracking
  { provide: TrackingService, useClass: GTMTrackingService },
  { provide: EventService, useClass: EventDataService },
  { provide: AdobeExperiencePlatformService, useClass: Capacitor.isNativePlatform() ? NativeAdobeExperiencePlatformService : DummyAdobeExperiencePlatformService },

    //Pdf Catalog
  { provide: PdfCatalogRepo, useClass: PdfCatalogDataRepo },

  //AppTrackingTransparency
  { provide: AppTrackingTransparencyService, useClass: CapacitorAppTrackingTransparencyService },

  //CookieBanner
  { provide: CookieBannerService, useClass: CookiebotCookieBannerService },

  // User Marketing Rules
  { provide: UserMarketingRulesRepository, useClass: UserMarketingRulesDataRepository },
  { provide: MessageDisplayStrategy, useClass: Capacitor.isNativePlatform() ? AppMessageDisplayStrategy : BrowserMessageDisplayStrategy },

  // Stored Payment Method
  { provide: StoredPaymentMethodRepository, useClass: StoredPaymentMethodDataRepository },

  // Payment Methods
  { provide: PaymentMethodsDTOFinder, useClass: PaymentMethodsDTODataFinder },
];

export const mockProviders = [

  // Category
  //{ provide: CategoryRemote, useClass: CategoryMockWebService },

  // Product
  //{ provide: ProductRemote, useClass: ProductMockWebService },

  // Promotion
  //{ provide: PromotionRemote, useClass: PromotionMockWebService },

  // Coupon
  //{ provide: CouponRemote, useClass: CouponMockWebService },

  // Order
  //{ provide: OrderRemote, useClass: OrderMockWebService },
]
